(function () {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function getSectionsUrl() {
    // Dawn uses the current page URL as sections_url
    return window.location.pathname + window.location.search;
  }

  async function changeLineItem(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: SECTIONS,
        sections_url: getSectionsUrl()
      })
    });

    if (!res.ok) throw new Error('cart/change failed');
    return res.json(); // Dawn-style payload (includes sections)
  }

  async function addVariant(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: SECTIONS,
        sections_url: getSectionsUrl()
      })
    });

    if (!res.ok) throw new Error('cart/add failed');
    return res.json(); // Dawn-style payload (includes sections)
  }

  function renderDrawerContents(payload) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return false;

    cartDrawer.renderContents(payload);
    cartDrawer.open();
    return true;
  }

  document.addEventListener(
    'click',
    async function (e) {
      const btn = e.target.closest('[data-upgrade]');
      if (!btn) return;

      e.preventDefault();

      const sourceKey = btn.getAttribute('data-source-key');
      const targetVariant = parseInt(btn.getAttribute('data-target-variant'), 10);
      if (!sourceKey || !targetVariant) return;

      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Upgrading…';

      try {
        // 1) Remove the source line item (returns Dawn payload w/ sections)
        const changePayload = await changeLineItem(sourceKey, 0);

        // 2) Add the upgraded variant (returns Dawn payload w/ sections)
        const addPayload = await addVariant(targetVariant, 1);

        // 3) If drawer exists, render updated HTML without closing
        const drawerUpdated = renderDrawerContents(addPayload);

        // 4) If no drawer (cart page), just reload
        if (!drawerUpdated) window.location.reload();
      } catch (err) {
        console.error('CraveX upgrade failed:', err);
        btn.disabled = false;
        btn.textContent = original;
        alert('Could not upgrade right now. Please try again.');
      }
    },
    { passive: false }
  );
})();

// (function () {
//   async function changeLineItem(lineKey, quantity) {
//     const res = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: lineKey, quantity })
//     });
//     if (!res.ok) throw new Error('cart/change failed');
//     return res.json();
//   }

//   async function addVariant(variantId, quantity) {
//     const res = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: variantId, quantity })
//     });
//     if (!res.ok) throw new Error('cart/add failed');
//     return res.json();
//   }

// //   function refresh() {
// //     window.location.reload();
// //   }

//   async function refresh() {
//     const cartDrawer = document.querySelector('cart-drawer');

//     // If cart drawer exists, refresh it without closing
//     if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//         const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

//         const res = await fetch(
//         `${window.Shopify.routes.root}?sections=${sectionsToRender.join(',')}`,
//         { credentials: 'same-origin' }
//         );

//         if (!res.ok) {
//         window.location.reload();
//         return;
//         }

//         const sections = await res.json();

//         cartDrawer.renderContents(sections);
//         cartDrawer.open();
//         return;
//     }

//         // Fallback for cart page
//         window.location.reload();
//     }

//   document.addEventListener(
//     'click',
//     async function (e) {
//       const btn = e.target.closest('[data-upgrade]');
//       if (!btn) return;

//       e.preventDefault();

//       const sourceKey = btn.getAttribute('data-source-key');
//       const targetVariant = parseInt(btn.getAttribute('data-target-variant'), 10);

//       if (!sourceKey || !targetVariant) return;

//       const original = btn.textContent;
//       btn.disabled = true;
//       btn.textContent = 'Upgrading…';

//       try {
//         await changeLineItem(sourceKey, 0);
//         await addVariant(targetVariant, 1);
//         await refresh();
//       } catch (err) {
//         console.error('CraveX upgrade failed:', err);
//         btn.disabled = false;
//         btn.textContent = original;
//         alert('Could not upgrade right now. Please try again.');
//       }
//     },
//     { passive: false }
//   );
// })();